import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          fontSize: '14px',
          '@media (min-width: 2000px)': {
            fontSize: '24px',
          },
          '@media (min-width: 2500px)': {
            fontSize: '32px',
          }
        },
      }
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          maxWidth: '72px',
          maxHeight: '29px',
          border: 'rgba(255, 255, 255, 1)',
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingRight: '15px `!`important',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: 'black',
        }
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: 'black',
        }
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: state => ({
          borderRadius: '45px',
          border: state.ownerState.selected ? '1px solid rgba(39, 39, 39, 1)' : 'none',
          backgroundColor: 'transparent !important',
          maxHeight: '40px',
          minWidth: '200px',
          textAlign: 'center',
        })
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'initial',
          color: '#171717',
          fontWeight: '800',
          fontSize: '30px',
          '@media (min-width: 2000px)': {
            fontSize: '32px',
          },
          '@media (min-width: 2500px)': {
            fontSize: '40px',
          }
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          height: '27px',
          borderRadius: '50px',
          boxSizing: 'border-box',
          color: 'rgba(255, 255, 255, 0.4)',
          padding: 0,
        },
        track: {
          backgroundColor: 'rgba(39, 39, 39, 1)',
        },
        rail: {
          border: '1px solid rgba(255, 255, 255, 1)',
        },
        thumb: {
          width: '40px',
          height: '40px',
          backgroundColor: 'rgba(255, 255, 255, 1)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: state => ({
          borderRadius: '0',
          border: '2px solid rgba(168, 222, 2, 1)',
          // width: '100%',
        }),
        input: {
          textAlign: 'center',
          '@media (min-width: 2000px)': {
            fontSize: '32px',
          },
          '@media (min-width: 2500px)': {
            fontSize: '40px',
          }          
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          position: 'relative',
          fontSize: '20px',
          fontFamily: 'Manrope',
          '@media (min-width: 2000px)': {
            fontSize: '32px',
          },
          '@media (min-width: 2500px)': {
            fontSize: '40px',
          }
        },
      },
    },
  },
  palette: {
    background: {
      default: 'rgba(245, 245, 245, 1)'
    },
    text: {
      primary: 'rgba(23 ,23 ,23 , 1)'
    },
    primary: {
      main: 'rgba(168, 222, 2, 1)',
      contrastText: 'rgba(23 ,23 ,23 , 1)'
    },
    secondary: {
      main: 'rgba(142, 142, 142, 1)'
    }

  },
  typography: {
    fontFamily: 'Manrope, sans-serif',
    body1: {
      fontFamily: 'Manrope, sans-serif',
      '@media (min-width: 2000px)': {
        fontSize: '24px',
      },
      '@media (min-width: 2500px)': {
        fontSize: '36px',
      }
    },
    body2: {
      fontFamily: 'Manrope, sans-serif',
      fontWeight: 400,
      fontSize: '26px',
      lineHeight: '1.4',
      '@media (max-width: 600px)': {
        fontSize: '16px',
      },
      '@media (min-width: 2000px)': {
        fontSize: '32px',
      },
      '@media (min-width: 2500px)': {
        fontSize: '46px',
      }
    },
    overline: {
      fontFamily: 'Manrope, sans-serif',
      textTransform: 'initial',
      fontWeight: 300,
      letterSpacing: '0.2px',
      '@media (min-width: 2000px)': {
        fontSize: '24px',
      },
      '@media (min-width: 2500px)': {
        fontSize: '32px',
      }
    },
    subtitle1: {
      fontFamily: 'Manrope, sans-serif',
      textTransform: 'initial',
      fontWeight: 275,
      letterSpacing: '0.2px',
    },
    subtitle2: {
      fontFamily: 'Manrope, sans-serif',
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '24.59px',
      color: '#8e8e8e',
      '@media (min-width: 2000px)': {
        fontSize: '32px',
      },
      '@media (min-width: 2500px)': {
        fontSize: '36px',
      }       
    }
  },
});
